import { render, staticRenderFns } from "./DetalleFactura.vue?vue&type=template&id=7ec02b05&"
import script from "./DetalleFactura.vue?vue&type=script&lang=js&"
export * from "./DetalleFactura.vue?vue&type=script&lang=js&"
import style0 from "./DetalleFactura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports